import { QueryClient } from '@tanstack/react-query';
import { staleTimes } from '@root/constants/queryKeys';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000,
      gcTime: 1000 * 60 * 60 * 24,
      staleTime: staleTimes.transactional
    }
  }
});
